import React from 'react';
import { withRouter } from 'react-router-dom';
import { setAjaxErrorHandler } from '@/utils/ajax';
import ErrorDialog from '@/components/dialogs/ErrorDialog';
import { getRelativePath } from '@/utils/url';
import { HttpStatusCode } from '@/HttpStatusCodes';

class AjaxErrorHandler extends React.Component {
    state = {
        showErrorDialog: false,
    };

    componentDidMount() {
        setAjaxErrorHandler(this.handleAjaxError);
    }

    componentWillUnmount() {
        setAjaxErrorHandler(null);
    }

    handleAjaxError = (response) => {
        const { history, location } = this.props;
        if (response.status === HttpStatusCode.Unauthorized /*|| response.status === 403*/) {
            if (!location.pathname.toLowerCase().startsWith('/login')) {
                let returnUrl = getRelativePath(location);

                let redirectTo = `/login`;

                if (returnUrl) {
                    redirectTo = redirectTo + '?returnUrl=' + encodeURIComponent(returnUrl);
                }

                history.push(redirectTo);
            }
            // } else if (response.status === HttpStatusCode.BadRequest || response.status === HttpStatusCode.Conflict) {
            //Do nothing
        } else {
            this.setState({
                showErrorDialog: true,
            });
        }
    };

    handleCloseErrorDialog = () => {
        this.setState({
            showErrorDialog: false,
        });
    };

    render() {
        // const { errorCode } = this.state;

        // if (errorCode === ErrorCodes.UNAUTHORIZED) {
        //     return (<CustomRedirect to={'/login'} />)
        // }

        const { showErrorDialog } = this.state;

        return <ErrorDialog show={showErrorDialog} onClose={this.handleCloseErrorDialog} />;
    }
}

export default withRouter(AjaxErrorHandler); 